// @ts-nocheck
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

import { setCurrentWarehouse, SetStoreWarehousesApiParameter } from "@store/Framework/Services/StoreWarehouseService";
import { StoreWarehouseModel } from "@store/Framework/Types/ApiModels";

type HandlerType = ApiHandler<SetStoreWarehousesApiParameter & HasOnSuccess & HasOnError<string>, StoreWarehouseModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadPickupWarehouses: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/StoreWarehouse/SetMyWarehouse",
        warehouse: props.apiResult,
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await setCurrentWarehouse(props.parameter);
    } catch (error) {
        if ("errorMessage" in error) {
            props.parameter.onError?.(error.errorMessage as string);
        }

        return false;
    }
};

export const DispatchSetMyWarehouse: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/StoreWarehouse/SetMyWarehouse",
        warehouse: props.apiResult,
        parameter: props.parameter,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchSetMyWarehouse, ExecuteOnSuccessCallback];

const setMyWarehouse = createHandlerChainRunner(chain, "SetMyWarehouse");
export default setMyWarehouse;
